export default function OrtodonciaPanel() {
  return (
    <section
      aria-label="Módulo de ortodoncia en construcción"
      style={{
        width: "100%",
        minHeight: 440,
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        borderRadius: 24,
        background: "linear-gradient(135deg, #eff6ff 0%, #f8fafc 55%, #ecfeff 100%)",
        border: "1px solid #dbeafe",
        overflow: "hidden",
        position: "relative"
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          width: 280,
          height: 280,
          borderRadius: "50%",
          background: "rgba(59, 130, 246, 0.10)",
          top: -120,
          right: -70
        }}
      />

      <div
        style={{
          width: "100%",
          maxWidth: 620,
          boxSizing: "border-box",
          padding: "38px 32px",
          borderRadius: 22,
          background: "rgba(255, 255, 255, 0.92)",
          border: "1px solid rgba(191, 219, 254, 0.9)",
          boxShadow: "0 18px 50px rgba(30, 64, 175, 0.10)",
          textAlign: "center",
          position: "relative"
        }}
      >
        <div
          aria-hidden="true"
          style={{
            width: 64,
            height: 64,
            margin: "0 auto 20px",
            borderRadius: 20,
            display: "grid",
            placeItems: "center",
            background: "#dbeafe",
            color: "#1d4ed8",
            fontSize: 30
          }}
        >
          ✦
        </div>

        <p
          style={{
            margin: "0 0 10px",
            color: "#2563eb",
            fontSize: 12,
            fontWeight: 800,
            letterSpacing: "0.14em",
            textTransform: "uppercase"
          }}
        >
          Ortodoncia · Próximamente
        </p>

        <h2
          style={{
            margin: "0 0 14px",
            color: "#0f172a",
            fontSize: "clamp(28px, 4vw, 42px)",
            lineHeight: 1.08,
            letterSpacing: "-0.04em"
          }}
        >
          Estamos construyendo este módulo
        </h2>

        <p
          style={{
            margin: "0 auto",
            maxWidth: 500,
            color: "#475569",
            fontSize: 16,
            lineHeight: 1.65
          }}
        >
          Las herramientas de cefalometría, Bolton, modelos STL y fabricación
          quedarán temporalmente fuera de servicio mientras rediseñamos el flujo
          completo para hacerlo claro, confiable y útil en clínica.
        </p>

        <div
          style={{
            marginTop: 26,
            padding: "14px 16px",
            borderRadius: 14,
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            color: "#64748b",
            fontSize: 13,
            lineHeight: 1.5
          }}
        >
          Tus estudios y archivos existentes se conservan. El módulo volverá a
          habilitarse cuando la nueva versión esté lista para revisión.
        </div>
      </div>
    </section>
  );
}
